import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TBundleLineInState } from './bundle-line-in-db.models';

export const selectBundleLineInStore = createFeatureSelector<TBundleLineInState>('BUNDLE_LINE_IN_STORE');

export const getTransactionLogInfo = createSelector(selectBundleLineInStore, (state) => state.transactionLogInfo);

export const getActivityLogInfo = createSelector(selectBundleLineInStore, (state) => state.activityLogInfo);
export const getRestoreCount = createSelector(selectBundleLineInStore, (state) => state.restoreCount);
